var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTilesAnnualAuditPercentage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.5 5.5V10",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 5.5V10",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 17.5H42.5",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5 41.5H12.5C9.186 41.5 6.5 38.814 6.5 35.5V13.5C6.5 10.186 9.186 7.5 12.5 7.5H36.5C39.814 7.5 42.5 10.186 42.5 13.5V35.5C42.5 38.814 39.814 41.5 36.5 41.5Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2974 33.7L28.6974 25.3",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.1383 35.1475C30.9199 34.3711 30.9108 33.1151 30.1411 32.3453C29.3724 31.5766 28.1184 31.5666 27.3418 32.3453C26.564 33.121 26.573 34.3728 27.339 35.1419C28.1144 35.9225 29.3683 35.9144 30.1383 35.1475Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6578 26.6555C22.4395 25.8791 22.4304 24.6231 21.6607 23.8534L21.655 23.8477C20.8825 23.0835 19.6395 23.0835 18.867 23.8477C18.0835 24.6229 18.0907 25.8789 18.8585 26.6498C19.6339 27.4305 20.8879 27.4224 21.6578 26.6555Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTilesAnnualAuditPercentage);
export default __webpack_public_path__ + "static/media/tiles-annualAuditPercentage.46cc3875239e81dc24f680524bdec2b6.svg";
export { ForwardRef as ReactComponent };